import { makePublicUrl } from 'app/utils/publicUrl'
import { LicenseType } from 'features/licenses/types'
import { prettyLicenseDescription } from 'features/licenses/utils'
import { ReclaimLicenseContentTitle } from '../../ReclaimLicenseModal/styles'

interface SelectedLicenseDescriptionCellProps {
  license: LicenseType
}

function SelectedLicenseDescriptionCell({
  license,
}: SelectedLicenseDescriptionCellProps) {
  return (
    <ReclaimLicenseContentTitle>
      <img src={makePublicUrl('images/license.svg')} alt="license icon" />
      {prettyLicenseDescription(license.description)}
    </ReclaimLicenseContentTitle>
  )
}
export default SelectedLicenseDescriptionCell
